import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AlertColor } from "@mui/material";

export interface INotification {
  show?: boolean;
  severity?: AlertColor;
  message?: string;
}

const initialState: INotification = {};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<INotification>) => {
      return {
        ...action.payload,
      };
    },
    resetNotification: (state) => {
      return {
        ...state,
        show: false,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNotification, resetNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
